<template>
  <div id="app">
    <nav-bar v-if="showNavBar"></nav-bar>
    <router-view/>
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue'

export default {
  name: 'app',
  components: {
    NavBar
  },
  computed: {
    showNavBar () {
      return ['unauthorized'].indexOf(this.$route.name) === -1
    }
  }
}
</script>

<style lang="scss">
  #app {
    background-image: url('assets/img/bg-flow-mobile.png');
    background-size: auto;
    background-position: center;
    min-height: 100vh;
    height: 100%;
    overflow: hidden;
  }
</style>
